import React, { useEffect, useState } from 'react';
const UNITS_KEY = 'bebe365_units_remaining';
const LAST_VISIT_KEY = 'bebe365_last_visit';
const TOTAL_UNITS = 500;
const MIN_START = 14;
const MAX_START = 20;
const RESET_TIMEOUT = 5 * 60 * 1000; // 5 minutes in ms
function getRandomStart() {
  return Math.floor(Math.random() * (MAX_START - MIN_START + 1)) + MIN_START;
}
export function TopBanner() {
  const [unitsRemaining, setUnitsRemaining] = useState<number>(() => {
    const lastVisit = localStorage.getItem(LAST_VISIT_KEY);
    const stored = localStorage.getItem(UNITS_KEY);
    // If user was away for more than 5 minutes, reset counter
    if (lastVisit) {
      const elapsed = Date.now() - parseInt(lastVisit);
      if (elapsed > RESET_TIMEOUT) {
        const newStart = getRandomStart();
        localStorage.setItem(UNITS_KEY, newStart.toString());
        return newStart;
      }
    }
    // Return stored value or generate random start
    if (stored) {
      return parseInt(stored);
    }
    const newStart = getRandomStart();
    localStorage.setItem(UNITS_KEY, newStart.toString());
    return newStart;
  });
  const [reachedZero, setReachedZero] = useState(unitsRemaining <= 0);
  useEffect(() => {
    // Update last visit timestamp periodically
    const updateVisit = () => {
      localStorage.setItem(LAST_VISIT_KEY, Date.now().toString());
    };
    updateVisit();
    const visitInterval = setInterval(updateVisit, 10000);
    // Countdown timer
    const countdown = setInterval(() => {
      setUnitsRemaining(prev => {
        if (prev <= 0) {
          setReachedZero(true);
          return 0;
        }
        const newVal = prev - 1;
        localStorage.setItem(UNITS_KEY, newVal.toString());
        if (newVal <= 0) {
          setReachedZero(true);
        }
        return newVal;
      });
    }, 45000);
    // Update last visit on page visibility change
    const handleVisibility = () => {
      if (!document.hidden) {
        updateVisit();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      clearInterval(countdown);
      clearInterval(visitInterval);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);
  if (reachedZero) {
    return <div role="banner" aria-label="Banner promocional" className="fixed top-0 left-0 right-0 z-[10000] bg-gradient-to-r from-[#8B4A52] via-[#B76E79] to-[#8B4A52] text-white text-center py-2.5 px-4 font-sans shadow-lg" data-id="element-381">
        <p className="m-0 text-sm leading-snug" role="status" aria-live="polite" data-id="element-382">
          🔥 <strong data-id="element-383">¡Aún estás a tiempo!</strong> — Obtén esta oferta antes de
          cerrar tu navegador.
        </p>
      </div>;
  }
  return <div role="banner" aria-label="Banner promocional" className="fixed top-0 left-0 right-0 z-[10000] bg-gradient-to-r from-[#8B4A52] via-[#B76E79] to-[#8B4A52] text-white text-center py-2.5 px-4 font-sans shadow-lg" data-id="element-384">
      <p className="m-0 text-sm leading-snug" data-id="element-385">
        🔥{' '}
        <strong className="text-sm sm:text-base tracking-wide" data-id="element-386">
          Precio de Lanzamiento 2026
        </strong>{' '}
        — Cupos limitados{' '}
        <span className="inline-block bg-white/20 rounded-md px-2 py-0.5 mx-1 text-base sm:text-lg font-bold tracking-widest font-mono" role="status" aria-live="polite" aria-label={`${unitsRemaining} de ${TOTAL_UNITS} unidades restantes`} data-id="element-387">
          🎟️ {unitsRemaining}/{TOTAL_UNITS}
        </span>{' '}
        <span className="hidden sm:inline" data-id="element-388">Unidades Restantes</span>
      </p>
    </div>;
}